<template>
  <div class="date-picker">
    <div class="label">
      <slot name="label" />
    </div>
    <date-picker
      v-model="dateVal"
      :range="range"
      :clearable="false"
      :range-separator="range ? ' - ' : ''"
      format="DD/MM/YYYY"
      :placeholder="placeholder"
    />
  </div>
</template>

<script>
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';

export default {
  name: 'custom-date-picker',
  components: {
    DatePicker,
  },
  props: {
    value: {
      type: [Date, String, Array],
      default: null,
    },
    range: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: 'Select date',
    },
  },
  computed: {
    dateVal: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
  },
};
</script>

<style lang="scss">
.date-picker {
  border: none;
  background: none;

  .label {
    color: #6e7c91;
    font-size: 9px;
    text-transform: uppercase;
  }

  .mx-datepicker {
    width: 110px;
  }

  .mx-datepicker-range {
    width: 100%;
    min-width: 210px;
  }

  .mx-input-wrapper {
    background-image: url('../../assets/icons/arrow-down.png');
    background-repeat: no-repeat;
    background-position: 100% 50%;
    background-size: 10px auto;
  }

  .mx-input {
    height: auto;
    border: none;
    background: none;
    box-shadow: none;
    font-family: "Proxima Nova";
    color: #6e7c91;
    font-size: 15px;
    font-weight: 700;
    padding: 0;
    cursor: pointer;
  }
  .mx-icon-calendar {
    display: none;
  }
}

.mx-calendar-content .cell.active {
  background-color: #6972de;
}

.mx-calendar-content .cell.in-range {
  background-color: #e5e8fd;
}
</style>
